import {Component, DestroyRef, OnInit, inject} from '@angular/core';

@Component({
  selector: 'app-base',
  template: '',
  standalone: true,
})
export class BaseComponent {
  destroyRef = inject(DestroyRef);

  constructor() {}
}
